import classNames from 'classnames';
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Container, Nav, Navbar } from 'react-bootstrap';
import handleNavbarTransparency from 'helpers/handleNavbarTransparency';
import { topNavbarBreakpoint } from 'config';
import AppContext from 'context/Context';
import { useTranslation } from 'react-i18next';
import CountrySelector from './CountrySelector';

const NavbarStandard = () => {
  const {
    config: { isDark }
  } = useContext(AppContext);
  const [navbarCollapsed, setNavbarCollapsed] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    window.addEventListener('scroll', handleNavbarTransparency);
    return () => window.removeEventListener('scroll', handleNavbarTransparency);
  }, []);

  const scrollTo = useCallback((e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      setNavbarCollapsed(true);
    }
  }, []);

  return (
    <Navbar
      variant={isDark ? 'light' : 'dark'}
      fixed="top"
      expand={topNavbarBreakpoint}
      className={classNames('navbar-standard navbar-theme', {
        'bg-100': !navbarCollapsed && isDark,
        'bg-dark': !navbarCollapsed && !isDark
      })}
    >
      <Container>
        <Navbar.Brand className="text-white dark__text-white fw-bold fs-2" as={Link} to="/">
          Gestodo
        </Navbar.Brand>
        <Navbar.Toggle onClick={() => setNavbarCollapsed(!navbarCollapsed)} />
        <Navbar.Collapse className="scrollbar">
          <Nav className="ms-auto align-items-center">
            <Nav.Item>
              <Nav.Link href="#features" onClick={e => scrollTo(e, 'features')} className="text-white fw-semi-bold">
                {t('LANDING.NAV_FEATURES')}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="#benefits" onClick={e => scrollTo(e, 'benefits')} className="text-white fw-semi-bold">
                {t('LANDING.NAV_BENEFITS')}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="#pricing" onClick={e => scrollTo(e, 'pricing')} className="text-white fw-semi-bold">
                {t('LANDING.NAV_PRICING')}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="#faq" onClick={e => scrollTo(e, 'faq')} className="text-white fw-semi-bold">
                {t('LANDING.NAV_FAQ')}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="ms-lg-3">
              <Button
                as={Link}
                variant="light"
                className="rounded-pill px-4 fw-semi-bold"
                to="/login"
              >
                {t('LANDING.NAV_CLIENTS')}
              </Button>
            </Nav.Item>
            <CountrySelector />
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarStandard;
